import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}
export function ProgressBar({
  currentStep,
  totalSteps
}: ProgressBarProps) {
  // Calculate progress percentage (0 to 100)
  const progress = Math.min(100, Math.max(0, currentStep / totalSteps * 100));
  return <div className="w-full max-w-md mx-auto mb-10 flex justify-center">
      <div className="font-semibold text-xl tracking-tight niyyah-gradient">
        Niyyah
      </div>
    </div>;
}